"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSideLock = exports.getOppositeApmSide = exports.APM_SIDES = void 0;
var APM_SIDES = exports.APM_SIDES = {
  BACK: '-1',
  FRONT: '1'
};
var isSideLock = exports.isSideLock = function isSideLock(lockId, side) {
  return side === APM_SIDES.FRONT ? Number(lockId) > 0 : Number(lockId) < 0;
};
var getOppositeApmSide = exports.getOppositeApmSide = function getOppositeApmSide(side) {
  return side === APM_SIDES.FRONT ? APM_SIDES.BACK : APM_SIDES.FRONT;
};